import React from 'react'
import styles from './vacancyDetailsLabel.module.scss'
import cn from 'classnames'

const VacancyDetailsLabel = ({ label, urgent, className }) => {
  return <label className={cn(styles.label, className, { [styles.urgentLabel]: urgent })}>{label}</label>
}

export default VacancyDetailsLabel
